import { Box as MuiBox } from "@mui/material"
import { ComponentProps } from "react"

import { uiskMuiSpacingMap, UiskSpacingProps } from "../utils/uiskMuiSpacingMap"

const Box = (
  props: Omit<ComponentProps<typeof MuiBox>, keyof UiskSpacingProps> &
    UiskSpacingProps,
) => {
  const muiSpacingProps = uiskMuiSpacingMap(props)
  return <MuiBox {...props} {...muiSpacingProps} />
}

export default Box
